export const initialValues = {
    message: '',

    variant: {
        id: '',
        title: '',
        price: 0,
        fee: 495,
    },

    quantity: 1,
    deliveryMethod: 'Text',
    deliveryDate: '',
    giftCardType: 'choose_your_own_restaurant',
};
